/**
 * Methods initializes all home JS features
 */
he.home.init = function () {
    this.keyVisualRotaryText();
};

/**
 *
 */
he.home.keyVisualRotaryText = function () {
    "use strict";
    /**
     * http://jsfiddle.net/W47QV/4/
     * @type {[string,string,string]}
     */
    const holder = document.getElementById('holder-text-animation');
    var $elementSpan = $(holder).find('.rotary-text');
    const delay = 2; //seconds

    (function loop(delay) {
        $.each(he.home.rotaryText, function (i, elm) {
            $elementSpan.delay(delay * 1E3).fadeOut();

            $elementSpan.queue(function () {
                $elementSpan.html(he.home.rotaryText[i]);
                $elementSpan.dequeue();
            });

            $elementSpan.fadeIn();

            $elementSpan.queue(function () {
                if (i == he.home.rotaryText.length - 1) {
                    loop(delay);
                }
                $elementSpan.dequeue();
            });
        });
    })(delay);
};